import {forwardRef, memo} from 'react';
import {Marker, Polygon} from '@/map/modules';
import {getPolygonPaths} from '@/map/utils';
import {Dot, PointDotProps} from './Dot';

interface IProps {
  map: naver.maps.Map;
  paths: naver.maps.PolygonOptions['paths'];
  colorOptions?: any;
  polygonOptions?: Omit<naver.maps.PolygonOptions, 'map' | 'paths'>;
  dotOptions?: PointDotProps & {
    filledEndDot?: boolean;
  };
  hiddenVertexMarker?: boolean;
  onLoaded?(instance: naver.maps.Polygon): void;
}

export const PolygonArea = memo(
  forwardRef<any, IProps>(
    (
      {
        map,
        paths,
        colorOptions,
        polygonOptions,
        dotOptions = {},
        hiddenVertexMarker,
        onLoaded,
      },
      ref
    ) => {
      if (!map || !paths) {
        return null;
      }
      const {filledEndDot, ...restDotOptions} = dotOptions;
      const path = getPolygonPaths(paths);

      return (
        <>
          <Polygon
            map={map}
            paths={paths}
            clickable={false}
            strokeWeight={2}
            ref={ref}
            onLoaded={onLoaded}
            {...colorOptions}
            {...polygonOptions}
          />
          {!hiddenVertexMarker &&
            path.map((i, idx: number) => (
              <Marker
                map={map}
                key={idx}
                position={i}
                draggable={false}
                clickable={false}
              >
                <Dot
                  borderColor={colorOptions?.strokeColor}
                  {...restDotOptions}
                />
              </Marker>
            ))}
        </>
      );
    }
  )
);
